import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/user',
  name: 'user',
  meta: {
    auth: true
  },
  redirect: {
    name: 'user/dept'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'user',
      name: `${pre}user`,
      component: _import('user/user'),
      meta: {
        title: '用户列表'
      }
    }, {
      path: 'user/add',
      name: `${pre}user-add`,
      component: _import('user/user/add'),
      meta: {
        title: '添加用户'
      }
    }, {
      path: 'user/edit',
      name: `${pre}user-edit`,
      component: _import('user/user/edit'),
      meta: {
        title: '编辑用户'
      }
    },
    {
      path: 'role',
      name: `${pre}role`,
      component: _import('user/role'),
      meta: {
        title: '角色列表'
      }
    },
    {
      path: 'role/add',
      name: `${pre}role-add`,
      //component: _import('user/role/add'),
      component: _import('user/role/edit'),
      meta: {
        title: '添加角色'
      }
    }, {
      path: 'role/edit',
      name: `${pre}role-edit`,
      component: _import('user/role/edit'),
      meta: {
        title: '编辑角色'
      }
    },
    {
      path: 'dept',
      name: `${pre}dept`,
      // component: _import('user/dept'),
      component: _import('user/dept/tree/index'),
      meta: {
        title: '部门列表'
      }
    },
    {
      path: 'reporter',
      name: `${pre}reporter`,
      // component: _import('user/dept'),
      component: _import('user/dept/tree/reporter'),
      meta: {
        title: '部门列表'
      }
    },
    {
      path: 'dept/add',
      name: `${pre}dept-add`,
      component: _import('user/dept/add'),
      meta: {
        title: '添加部门'
      }
    }, {
      path: 'dept/edit',
      name: `${pre}dept-edit`,
      component: _import('user/dept/edit'),
      meta: {
        title: '编辑部门'
      }
    }

    , {
      path: 'test',
      name: `${pre}dept-test`,
      component: _import('user/test'),
      meta: {
        title: '编辑部门'
      }
    }

  ])('user/')
}
